interface InitialValueForm {
  options: {defaultValues: Record<string, unknown>}
  update(options: {defaultValues: Record<string, unknown>}): void
  setFieldValue(name: string, value: unknown, options?: {dontRunListeners?: boolean; dontUpdateMeta?: boolean}): void
}

/**
 * Sets fields that are prefilled from the loaded resource (compound mapping, patient, ...) and folds
 * them into the form's default values, so opening a form with initial data is not an unsaved change.
 *
 * Takes the form as `unknown` because each form's default-values type has its own shape.
 */
export function setInitialFieldValues(form: unknown, values: Record<string, unknown>) {
  const target = form as InitialValueForm
  target.update({defaultValues: {...target.options.defaultValues, ...values}})

  for (const [name, value] of Object.entries(values)) {
    target.setFieldValue(name, value, {dontRunListeners: true, dontUpdateMeta: true})
  }
}
